<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import Skeleton from '@uiKit/elements/Skeleton.vue'
import { TokenDiamondIcon } from '@uiKit/icons'

interface Props {
  /** Pre-formatted total, e.g. `"98,722,222"`. */
  total?: string
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  total: '',
  loading: false,
})
</script>

<template>
  <Box align="center" justify="between" gap="4" is="section" class="ttb">
    <Text type="body" weight="bold" color="muted" transform="uppercase" is="span">
      Total Tokens
    </Text>

    <Box align="center" gap="2" class="ttb__value">
      <TokenDiamondIcon :size="44" />
      <Skeleton v-if="loading" animation="wave" width="140px" height="30px" />
      <Text v-else type="display" weight="semibold" is="p" class="ttb__amount">
        {{ total || '0' }}
      </Text>
    </Box>
  </Box>
</template>

<style scoped>
.ttb {
  background: var(--p-surface-50);
  border: 1px solid var(--p-content-border-color);
  border-radius: 16px;
  padding: 0.75rem 1.125rem;
  box-sizing: border-box;
}

.ttb__value {
  flex-shrink: 0;
}

.ttb__amount {
  font-variant-numeric: tabular-nums;
}
</style>
